var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "width": "9",
      "height": "16",
      "viewBox": "0 0 9 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M5.422 16V8.711h2.49l.355-2.844H5.422V4.089c0-.8.267-1.422 1.422-1.422h1.512V.089C8 .089 7.11 0 6.133 0 4 0 2.49 1.333 2.49 3.733v2.134H0V8.71h2.489V16h2.933z",
      "fill": "#fff"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }